import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';;
import { JourneysService } from 'src/app/data/repositories/journeys/journeys.service';
import { LoaderService } from 'src/app/shared/services/loader/loader.service';
import { AuthenticationService } from '../services/authentication.service';
import moment from 'moment-timezone';
import { AppSelectorService } from 'src/app/shared/services/app-selector/app-selector.service';
const INDIAN_TIMEZONE = 'Asia/Kolkata';

@Component({
  selector: 'app-onsite-journey',
  templateUrl: './onsite-journey.component.html',
  styleUrls: ['./onsite-journey.component.scss']
})
export class OnsiteJourneyComponent implements OnInit {
  public shouldShowError: boolean = false;
  private onsiteJourneyData: any;

  constructor(private router: Router,
    private activatedRoute: ActivatedRoute,
    private journeysService: JourneysService,
    private loaderService: LoaderService,
    private authenticationService: AuthenticationService,
    private appSelectorService: AppSelectorService) { }

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe(queryParams => {
      if (Object.keys(queryParams).length) {
        if (queryParams.error) {
          console.log('queryParams has error');
          this.showError();
        } else {
          this.setupListeners();
        }
      } else {
        this.setupListeners();
      }
    });
  }

  setupListeners() {
    this.onsiteJourneyData = JSON.parse(this.authenticationService.getLocalStorageKey('onsiteJourneyData'));
    if (!this.onsiteJourneyData) {
      console.log('data not found in ls');
      this.showError();
      return;
    }
    // https://diltest.hansel.io/auth/ce-authenticate?uuid=6461caf87306d&appId=c4793e8c71b47ae2d75836152db62ea5&startDate=2023-06-23%2006:00:00&endDate=2023-06-23%2014:00:00&type=CE&ceeJourneyId=100&pxJourneyName=erhgsdvdf3455&pullListId=1327&ceeJourneyName=Web%20activity&pxJourneyId=

    this.appSelectorService.loadApps(null, this.handleOnsiteJourneyRequest);
  }

  handleOnsiteJourneyRequest = () => {
    if (!this.onsiteJourneyData.pxJourneyId) {
      const payload: any = {
        app_id: this.onsiteJourneyData.appId,
        smt_jid: this.onsiteJourneyData.ceeJourneyId,
        smt_jname: decodeURI(this.onsiteJourneyData.ceeJourneyName),
        step: 1,
        name: decodeURI(this.onsiteJourneyData.pxJourneyName),
        desc: '',
        dashboard_version: '3.0',
        events: [],
        jid: '',
        never_ending: false,
        supported_nudge_type: 'prompt'
      };
      let timeZone;
      if (this.onsiteJourneyData.tz) {
        timeZone = this.onsiteJourneyData.tz;
      } else {
        timeZone = INDIAN_TIMEZONE;
      }
      const startDateTZ = moment.tz(decodeURI(this.onsiteJourneyData.startDate), 'YYYY-MM-DD HH:mm:ss', timeZone);
      const endDateTZ = moment.tz(decodeURI(this.onsiteJourneyData.endDate), 'YYYY-MM-DD HH:mm:ss', timeZone);
      const indianStartDate = startDateTZ.clone().tz(INDIAN_TIMEZONE);
      const indianEndDate = endDateTZ.clone().tz(INDIAN_TIMEZONE);
      console.log(`IST Start time: ${parseInt(moment.utc(indianStartDate, 'x', true).format('x'), 10)}`);
      console.log(`IST End time: ${parseInt(moment.utc(indianEndDate, 'x', true).format('x'), 10)}`);
      // const startDate = moment(decodeURI(this.onsiteJourneyData.startDate), 'YYYY-MM-DD HH:mm:ss');
      // const endDate = moment(decodeURI(this.onsiteJourneyData.endDate), 'YYYY-MM-DD HH:mm:ss');
      payload.start_date = parseInt(moment.utc(indianStartDate, 'x', true).format('x'), 10);
      if (endDateTZ.year() === 2085) {
        payload.end_date = 0;
        payload.never_ending = true;
      } else {
        payload.end_date = parseInt(moment.utc(indianEndDate, 'x', true).format('x'), 10);
      }
      this.upsertJourney(payload);
    } else {
      // redirect to journey page
      this.router.navigate([`context-builder/nudge-journeys/journey-builder/${this.onsiteJourneyData.appId}/${this.onsiteJourneyData.pxJourneyId}`], { queryParams: { 'tab': 1 } });
    }
  }

  upsertJourney(payload) {
    this.journeysService.upsertJourney(payload, false).subscribe((res: any) => {
      if (res.is_error) {
        console.log('journey creation API faild :(');
        this.showError();
        return;
      }
      this.router.navigate([`context-builder/nudge-journeys/journey-builder/${this.onsiteJourneyData.appId}/${res.api_response.journey_id}`], { queryParams: { 'tab': 1 } });
    }, e => { this.showError() });
  }

  showError() {
    this.shouldShowError = true;
    this.loaderService.hide('#onsite-fullscreen-loader');
  }

  goBack() {
    this.authenticationService.cePostMessage({ px_journey_id: null, action: 'close' });
  }
}
